import React from "react";

const Authorization = () => {
  return !!localStorage.getItem("user");
};

export default Authorization;
